import type {
  RolesResponse,
  RoleResponse,
  RoleCreateParams,
  RoleUpdateParams,
  RoleDeleteParams,
} from '../types/roles'
import { fetchOptions } from './csrf'

export const rolesApi = {
  async getRoles(): Promise<RolesResponse> {
    const response = await fetch('/api/v1/roles', fetchOptions())
    if (!response.ok) {
      const data = await response.json().catch(() => ({}))
      throw new Error(data.error || 'Failed to load roles')
    }
    return response.json()
  },

  async getRole(id: string): Promise<RoleResponse> {
    const response = await fetch(`/api/v1/roles/${id}`, fetchOptions())
    if (!response.ok) {
      const data = await response.json().catch(() => ({}))
      throw new Error(data.error || 'Failed to load role')
    }
    return response.json()
  },

  async createRole(params: RoleCreateParams): Promise<RoleResponse> {
    const response = await fetch('/api/v1/roles', {
      ...fetchOptions('POST'),
      body: JSON.stringify({ role: params }),
    })
    if (!response.ok) {
      const data = await response.json().catch(() => ({}))
      throw new Error(data.errors?.join(', ') || data.error || 'Failed to create role')
    }
    return response.json()
  },

  async updateRole(id: string, params: RoleUpdateParams): Promise<RoleResponse> {
    const response = await fetch(`/api/v1/roles/${id}`, {
      ...fetchOptions('PATCH'),
      body: JSON.stringify({ role: params }),
    })
    if (!response.ok) {
      const data = await response.json().catch(() => ({}))
      throw new Error(data.errors?.join(', ') || data.error || 'Failed to update role')
    }
    return response.json()
  },

  async deleteRole(id: string, params?: RoleDeleteParams): Promise<{ message: string }> {
    let url = `/api/v1/roles/${id}`
    if (params?.reassign_to) {
      url += `?reassign_to=${params.reassign_to}`
    }
    const response = await fetch(url, fetchOptions('DELETE'))
    if (!response.ok) {
      const data = await response.json().catch(() => ({}))
      throw new Error(data.error || 'Failed to delete role')
    }
    return response.json()
  },
}
